<template lang="pug">
.svgWrapper
  component(
    :is="currentIcon"
    v-if="currentIcon"
    :iconName="iconName"
    :iconColor="colorBind"
    :width="svgSize"
    :height="svgSize"
    class="svg-icon"
  )
</template>

<script setup lang="ts">
import { defineAsyncComponent, computed } from 'vue';
import { sizes, type IconProps } from './Icon.types';
import { iconDefaults } from './Icon.defaults';

const props = withDefaults(defineProps<IconProps>(), {
  size: iconDefaults.size,
  iconColor: iconDefaults.iconColor,
});

const getVarOrColorValue = (str: string) => {
  return str.startsWith('var:')
    ? str.replace(/^var:/, `var(--${iconDefaults.varPrefix}`) + ')'
    : str;
};

const svgSize = computed(
  () => `${sizes[props.size as keyof typeof sizes].size}`,
);

const colorBind = computed(() => {
  const color = props.iconColor ? props.iconColor : iconDefaults.iconColor;
  return getVarOrColorValue(color as string);
});

const iconName = computed(() => props.iconName);

const currentIcon = computed(() =>
  defineAsyncComponent(
    () =>
      import(`../../arche/primitives/Icons/${props.iconName || 'lines'}.vue`),
  ),
);
</script>

<style lang="scss" scoped>
.svgWrapper {
  display: inherit;
  align-items: inherit;
}

.svg-icon {
  color: v-bind('colorBind');
  aspect-ratio: 1/1;

  .iconIsAnimated & {
    width: 100%;
    height: 100%;
    animation: 2s ease 0s infinite normal none running sdb05;
  }
}

@keyframes sdb05 {
  0% {
    opacity: 0;
    transform: translateY(-8px);
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translateY(8px);
  }
}
</style>
